import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './baseQuery';

export const baseApi = createApi({
    tagTypes: [
        'BranchDebts',
        'StudentDebts',
        'BranchTeacherActiveLessons',
        'AttendanceHistory',
        'AccountRegistrationStatus',
        'Avatar',
        'GroupStudent',
        'CoinBalanceTransaction',
        'CoinBalance',
        // Legacy?
        'GroupMaterials',
        'HomeworkSolutions',
        'Group',
        'BranchTeacherGroups',
        'Student',
        'Timetable',
        'User',
        'CurrentUser',
        'Branches',
        'Employee',
        'Performance',
        'ChatMessage',
        'Materials',
        'Subjects',
        'Practice',
        'Audience',
        'Academic',
        'LessonMaterial',
        'LessonAttendance',
        'StudentAttendance',
    ],
    reducerPath: 'mpApi',
    baseQuery: axiosBaseQuery,
    endpoints: () => ({}),
});
